import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material'

const Link: React.FC<MuiLinkProps> = ({ children, ...props }) => {
  return <MuiLink {...props}>{children}</MuiLink>
}

export default Link
export type { MuiLinkProps as LinkProps }
